// extracted by mini-css-extract-plugin
export default {"motionBg":"wave-bg_motionBg__GSpJ-"};